// extracted by mini-css-extract-plugin
export var heroTitle = "hero-module--heroTitle--jg603";
export var heroSubTitle = "hero-module--heroSubTitle--qI4Kb";
export var heroImg = "hero-module--heroImg--8ZLqY";